<template>
    <div class="layout">
        <header-bar :logined="logined" @menuToggle="menuToggle"></header-bar>
        <!--<div class="header-inner">
            <a href="/"><img :src="logoUrl" class="logo"></a>
                <div class="navSearchBox">
                        <form action="/search" target="_blank">
                            <a href="javascript:;" class="navSearchIcon" @click="goSearch">
                                <div class="navSearchIconIcon"></div>
                            </a>
                            <input type="text" class="navSearch placeholder" id="keyWord" name="q" onkeyup="_search(event)" placeholder="搜索您想了解的数据"/>
                        </form>
                    </div>
                <div class='clearfix'></div>
        </div>-->
        <div class='navwrap'>
            <div class='nav detailNav'>
                <div class='navBox'>
                    <ul class='navUl'>
                        <li class='navLi' v-for='ele in nav.content' @mouseenter='me(ele.name)' @mouseleave='ml' :key="ele.name">
                            <span class='navSpan' @click='toUrl(ele.url)'>{{ele.name}}</span>
                            <template v-show='ele.children.length!==0'>
                                <ul class='drag' v-show='nav.state==ele.name&&ele.children.length!==0'>
                                    <li class='dragLi' v-for='item in ele.children' @mouseenter='subme(item.name)'
                                    @mouseleave='subml' :key="item.name">
                                        <a class='dragLi-word' :href='item.url'>
                                            {{item.name}}
                                        </a>
                                        <template v-show='item.children!==[]'>
                                                <ul class='drag sub-drag' v-show='nav.substate==item.name&&item.children.length!==0'
                                                    @mouseleave='subml'>
                                                    <li class='dragLi' v-for='one in item.children' :key="one.value">
                                                        <a class='dragLi-word'>
                                                            <router-link :to="{name:'line_c',params:{line_id:one.value}}">{{one.name}}</router-link>
                                                        </a>
                                                    </li>
                                                </ul>
                                        </template>
                                    </li>
                                    <div class='dragAngel'>
                                    </div>
                                </ul>
                            </template>
                        </li>
                    </ul>

                </div>
            </div>
        </div>
        <div class="med-wrapper-box">
                <Breadcrumb class="bread-wrapper" separator=">">
                    <BreadcrumbItem v-for="ele in breadlist" :key="ele.name"><a :href="ele.link">{{ele.name}}</a></BreadcrumbItem>
                </Breadcrumb>
                    <div>
                        <Content class="m-content-wrapper">
                            <router-view name="leftBar"></router-view>
                            <router-view></router-view>
                        </Content>
                    </div>
            </div>

            <footer-bar></footer-bar>
            <div class="menu-bar" v-show="menuIfShow" @mouseenter="menuToggle(true)" @mouseleave="menuToggle(false)">
            <menu-bar></menu-bar>
        </div>
    </div>
</template>
<script>
    import footerBar from './FooterBar.vue'
    import headerBar from './HeaderBar.vue'
    import menuBar from './MenuBar.vue'

    export default {
        name: "innerFrame",
        components: {
            footerBar,
            headerBar,
            menuBar
        },
        data() {
            return {
                imgUrl: process.env.BASE_URL + "img/login_bg.jpg",
                logoUrl: process.env.BASE_URL + "img/logo.png",
                /*nav: {
                    state: "",
                    substate: "",
                    content: this.nav_content
                },*/
                nav: {
                    state: '',
                    substate: '',
                    content: [
                        {
                            name: '首页',
                            url: '/index',
                            children: []
                        },
                        {
                            name: '产品物料信息',
                            url: undefined,
                            children: [
                            { name: "原材料", url: "/item/material", children: [] },
                            { name: "壳体", url: "/item/shell", children: [] },
                            { name: "蓄能器", url: "/item/accumulator", children: [] },
                            { name: "库存物品", url: "/item/goods", children: [] },
                            ]
                        },
                        {
                            name: '采购管理',
                            url: undefined,
                            children: [
                            { name: "采购审核", url: "/item/purchaseVerify", children: [] },
                            { name: "采购执行", url: "/item/purchaseOperation", children: [] },
                            { name: "采购入库", url: "/item/purchaseIn", children: [] },
                            ]
                        },
                        {
                            name: '试验检测报告',
                            url: undefined,
                            children: [
                            { name: "热处理报告", url: "/archiveManage/heatReport", children: [] },
                            { name: "硬度试验报告", url: "/archiveManage/hardReport", children: [] },
                            { name: "渗透检测报告", url: "/archiveManage/ptReport", children: [] },
                            { name: "水压试验报告", url: "/archiveManage/hydraulicReport", children: [] },
                            { name: "磁粉检测报告", url: "/archiveManage/mtReport", children: [] },
                            { name: "密封及动作性能", url: "/archiveManage/oilReport", children: [] },
                            ]
                        },
                        /*{
                            name: '信息资料查询',
                            url: undefined,
                            children: [
                            { name: "材料数据", url: "/archive/mat_l", children: [] },
                            { name: "标准查询", url: "/archive/standard_l", children: [] },
                            { name: "失效案例", url: "/archive/ra_l", children: [] },
                            ]
                        },
                        {
                            name: '通知信息一览',
                            url: undefined,
                            children: [
                            { name: "总公司通知事项", url: "/inform/c", children: [] },
                            { name: "检测中心通知", url: "/inform/i", children: [] },
                            { name: "个人业务相关", url: "/inform/w", children: [] },
                            ]
                        },*/
                        {
                            name: '下载中心',
                            url: '/rearService_i/download',
                            children: [
                            ]
                        },
                        /*{
                            name: '常用链接',
                            url: 'http://m.shsaien.com',
                            children: [
                            ]
                        },*/
                    ]
                },
                logined: false,
                loginAuth: [
                ],
                nav_content: [],
                menuIfShow:false,

            }
        },
        created() {
            let userToken = localStorage.getItem("current_user_token");
            if (userToken === undefined || userToken === null) {
                localStorage.clear();
                window.location.href='/system_login';
            }
        },
        mounted() {
        },
        props: {
            breadlist: {
                type: Array,
                default() {
                    return [];
                }
            },
        },
        methods: {
            me: function (name) {
                this.nav.state = name;
            },
            ml: function () {
                this.nav.state = '';
            },
            subme: function (name) {
                this.nav.substate = name;
            },
            subml: function () {
                this.nav.substate = '';
            },
            toUrl: function (url) {
                if (url) {
                    location.href = url;
                }
            },
            LogOut: function () {
                localStorage.clear();
                this.logined = false;
                location.href = "/login";
            },
            goSearch:function(){
                location.href = "/search/search_result";
            },
            menuToggle:function(val){
                this.menuIfShow = val;
            }

        }

    }
</script>

<style scoped>
    a {
        color: inherit;
    }

    a:hover {
        color: inherit;
    }
    body{
        background:#f5f5f5;
    }



    a:active {
        color: inherit;
    }

    header {
        width: 100%;
        background-color: #fff;
    }

    .header-inner {
        padding: 15px 0;
        width: 1260px;
        margin: 0 auto;
    }

    .search {
        margin-top: 15px;
        background: #fff;
        border: 1px solid #ccc;
        border-radius: 25px;
        float: right;
        overflow: hidden;
        height: 27px;
        width: 190px;
        padding: 0px 10px;
    }

    .search-logo {
        padding-top: 5px;
        cursor: pointer;
    }

    .search-input {
        width: 85%;
    }

    .search-input>input {
        width: 100%;
        outline: none;
        height: 27px;
    }

    .logo {
        width: 600px;
        margin-top:15px;
    }

    .pull-left {
        float: left;
    }

    .pull-right {
        float: right;
    }

    .navwrap {
        height: 100px;
        border-bottom: 1px solid #eee;
    }

    .detailNav {
        
        height: 100px;
        overflow: visible;
    }

    .nav {
        width: 100%;
        height: 0;
        margin: 0 auto;
        /* position: relative; */
        background: rgb(255, 255, 255);
        /* overflow: hidden; */
    }

    .navBox {
        width: 1260px;
        height: auto;
        margin: 0 auto;
        background: white;
    }

    .navImg {
        width: 104px;
        height: 53px;
        float: left;
        margin-top: 24px;
    }

    .navImg img {
        width: 100%;
        height: 100%;
    }

    .navUl {
        float: left;
        width: auto;
        height: 100%;
        /* margin-right: 700px; */
    }

    .navLi {
        width: auto;
        height: 100px;
        line-height: 100px;
        font-size: 16px;
        color: rgb(51, 51, 51);
        float: left;
        position: relative;
        cursor: pointer;
        text-align: center;
        margin: 0 70px 0 0;
        list-style: none;
        color: rgb(51, 51, 51);
    }

    .navSpan:hover {
        color: #993333;
    }

    .drag {
        width: 150px;
        height: auto;
        padding: 10px 0;
        box-shadow: 0 4px 8px rgba(0, 0, 0, .15);
        position: absolute;
        z-index: 9999;
        top: 97px;
        left: -28px;
        border-right: 1px solid rgba(0, 0, 0, .15);
        border-left: 1px solid rgba(0, 0, 0, .15);
        border-bottom: 1px solid rgba(0, 0, 0, .15);
        border-top: 3px solid #993333;
        background: #f9faff;
    }

    .sub-drag {
        border-top:none;
        top: 2px;
        left: 150px;
    }

    .navBor {
        position: absolute;
        width: 1px;
        background: #eeeeee;
        height: auto;
        top: 10px;
        left: 200px;
    }

    .dragLi {
        width: 150px;
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        text-align: center;
        list-style: none;
        position: relative;
    }

    .dragLi-word {
        width: 100%;
        float: left;
        text-align: center;
    }

    .dragLi-word:hover {
        color: #993333;
        transition: color 0.1s ease;
    }

    .dragAngel {
        width: 0;
        height: 0;
        position: absolute;
        overflow: hidden;
        font-size: 0;
        top: -13px;
        left: 66px;
        line-height: 0px;
        border-width: 0px 10px 10px;
        border-style: solid solid solid solid;
        border-left-color: transparent;
        border-right-color: transparent;
        border-top-color: transparent;
        border-bottom-color: #993333;
    }
    .med-wrapper-box {

        margin: 0 auto;
        width: 100%;
        min-width: 1250px;
        margin-bottom: 60px;
        background-color: #fff;
    }

    .m-content-wrapper {
        background: #fff;
        width:1260px;
        margin: 0 auto;
        min-height:600px;
    }
    .navSearchBox {
    /* width: auto; */
    height: 46px;
    width: 45%;
    float: right;
    margin-top: 27px;
}
.navSearchIcon {
    width: 46px;
    height: 40px;
    background: #993333;
    /* background: url(../images/1-3.jpg) no-repeat 50% 50%; */
    /* background-size: contain; */
    float: right;
    position: relative;
    cursor: pointer;
    overflow: hidden;
}
.navSearch {
    width: 250px;
    height: 40px;
    border: none;
    outline: none;
    border: 1px solid #993333;
    float: right;
    padding: 2px 0 2px 10px;
    font-size: 16px;
    line-height: 40px;
}
.placeholder {
    color: #AAA;
}
.navSearchIconIcon {
    width: 20px;
    height: 20px;
    background: url(../assets/search.png) no-repeat 50% 50%;
    /* background-size: 100%; */
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}

.bread-wrapper{
    width:1260px;
    margin:20px auto;
}
.menu-bar{
    position: absolute;
    left:0;
    top:37px;
    z-index: 999;
}
</style>